function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width:".concat(n, ")");
};

var aliases = ['sm', 'md', 'lg', 'xl', 'xxl'];
var breakpointStrings = [576, 768, 992, 1200, 1400].map(function (n) {
  return "".concat(n, "px");
});
var breakpoints = breakpointStrings.reduce(function (acc, curr, index) {
  return Object.assign({}, acc, _defineProperty({}, "".concat(aliases[index]), curr));
}, {});
var mediaQueries = breakpointStrings.map(createMediaQuery).reduce(function (acc, curr, index) {
  return Object.assign({}, acc, _defineProperty({}, "".concat(aliases[index]), curr));
}, {});
export { breakpoints, breakpointStrings, mediaQueries };